<template>
  <div>
    <div v-for="(item, idx) in items" :key="idx">
      <ContainerPrototypeItem
        :visible="item.flag"
        :key="item.id"
        :id="item.id"
        @delete="removeItem"
      >
        <template v-slot:title>
          <b-input-group>
            <b-form-input
              aria-label="Qty"
              placeholder="Qty"
              class="text-center col-5"
              v-model="item.qty"
            ></b-form-input>
            <b-form-input
              aria-label="Commodity"
              placeholder="Commodity"
              class="text-center"
              v-model="item.commodity"
            ></b-form-input>
            <b-form-input
              aria-label="Description"
              placeholder="Description"
              class="text-center"
              v-model="item.description"
            ></b-form-input>
          </b-input-group>
        </template>
      </ContainerPrototypeItem>
    </div>
    <hr class="my-0">
    <b-button
      variant="outline-dark"
      class="mt-3 text-xs"
      @click="addNewItem()"
    >
      Add Item
    </b-button>
  </div>
</template>

<script>
import ContainerPrototypeItem from './ContainerPrototypeItem.vue';

export default {
  name: 'ContainerPrototypeList',
  props: ['items'],
  methods: {
    removeItem(id) {
      this.$emit('remove', id);
    },
    addNewItem() {
      this.$emit('add');
    },
  },
  components: { ContainerPrototypeItem },
};
</script>

<style scoped>

</style>
